module.exports = __webpack_public_path__ + "img/beer_id-5.c174b163.jpg";